declare var require: any;
var mixitup = require('../node_modules/mixitup/dist/mixitup.min.js');
var mixitupMultifilter = require('../wwwroot/js/mixitup-multifilter.min.js');
mixitup.use(mixitupMultifilter);

interface changelogItem {
  changelogEN: changelogLang[];
  changelogSV: changelogLang[];
  datePublished: string;
  changelogVideo: string;
  changelogVideo_2: string;
  changelogVideo_3: string;
  isPatch: boolean;
  projectID: number;
  projectTitle: string;
  versionID: number;
  versionName: string;
}
interface changelogLang {
  area: string;
  id: number;
  isTopNews: boolean;
  languageCode: string;
  originalText: string;
  rawText: string;
  text: string;
  type: string;
}
interface changelogMajor {
  name: string;
  items: changelogItem[];
}
interface changeLogBtn {
  title: string;
  id: number;
}
interface changelogVersions {
  id: number;
  isPatch: boolean;
  lastPublished: string;
  projectId: number;
  versionName: string;
  videoURL: string;
}
const customOrder = [
  'General',
  'Manufacturing',
  'Purchase',
  'Sales',
  'Stock',
  'Time recording',
  'Accounting',
  'General registers',
    'EDI',
    'Monitor BI',
  'Monitor Mobile',
];
const customOrderSwedish = [
  'Allmänt',
  'Tillverkning',
  'Inköp',
  'Försäljning',
  'Lager',
  'Tidrapportering',
  'Redovisning',
  'Generella register',
    'EDI',
    'Monitor BI',
  'Monitor Mobile',
];

function customSort(a, b, orderItem) {
  const indexA = orderItem.indexOf(a.area);
  const indexB = orderItem.indexOf(b.area);

  if (indexA === -1 && indexB === -1) {
    return a.area.localeCompare(b.area);
  } else if (indexA === -1) {
    return 1;
  } else if (indexB === -1) {
    return -1;
  } else {
    return indexA - indexB;
  }
}

let currentSortOrder = customOrder;
var changelogCategories: string[] = [];
const objArray: { projectName: string }[] = [];
var allResults: changelogItem[] = [];
var changelogLangArr: changelogLang[] = [];

let patchCategory = { area: '', value: '' };
var lang = document.documentElement.lang;
async function getChangelogTitles() {
  try {
    const response = await fetch(
      'https://changelogapi.monitor.se/api/Changelog/Projects?apiKey=XMEWLZiFKmWHFBHspqNW_7dO4pZgzzhpadHOz9ksB_r2DF8gHB1o8mI3XXZ6Je',
      {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();

    createFilters(result);
    var btnContainer = document.getElementById('filter-container');
    var firstBtnItem = btnContainer.children[0];
    var btnText = '';

    if (firstBtnItem != undefined) {
      btnText = firstBtnItem.textContent.replace(/ /g, '+');
      getChangelogVersions(result[0].id, true);
      firstBtnItem.classList.add('mixitup-active-button');
    }
    return allResults;
  } catch (err) {}
}
getChangelogTitles();

async function getChangelogVersions(projectId: string, urlVersion: boolean) {
  var changelogVersions: string[] = [];
  var apiUrl =
    'https://changelogapi.monitor.se/api/Changelog/Versions?apiKey=XMEWLZiFKmWHFBHspqNW_7dO4pZgzzhpadHOz9ksB_r2DF8gHB1o8mI3XXZ6Je';
  if (projectId != '') {
    apiUrl += '&projectId=' + projectId;
  }
  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();
    for (var i = 0; i < result.length; i++) {
      var resultItem = result[i].versionName;
      resultItem = resultItem.split('.', 2).join('.');

      if (
        changelogVersions.indexOf(resultItem) == -1 ||
        changelogVersions.length == 0
      ) {
        changelogVersions.push(resultItem);
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const versionName = urlParams.get('VersionName');

    createDropdownItems(
      changelogVersions,
      'version-select',
      false,
      projectId,
      urlVersion
    );

    if (versionName != null && urlVersion == true) {
      getChangelog(projectId, versionName, urlVersion, '');
    } else {
      var searchStr = '';
      var searchInput = document.getElementById(
        'changelog-search'
      ) as HTMLInputElement;
      if (searchInput.value) {
        searchStr = searchInput.value;
      } else if (searchStr == '') {
        getChangelog(projectId, changelogVersions[0], false, '');
      } else {
        getChangelog('', '', false, searchStr);
      }
    }

    return result;
  } catch (err) {}
}
function compareVersions(versionA: string, versionB: string): number {
  const aComponents = versionA
    .split('.')
    .map((component) => parseInt(component));
  const bComponents = versionB
    .split('.')
    .map((component) => parseInt(component));

  for (let i = 0; i < Math.max(aComponents.length, bComponents.length); i++) {
    const aComponent = aComponents[i] || 0;
    const bComponent = bComponents[i] || 0;

    if (aComponent > bComponent) {
      return -1;
    } else if (aComponent < bComponent) {
      return 1;
    }
  }

  return 0;
}
async function getChangelog(
  projectId: string,
  versionName: string,
  urlVersion: boolean,
  searchStr: string,
  preFilter?: string
) {
  var fetchUrl =
    'https://changelogapi.monitor.se/api/changelog/changes?apiKey=XMEWLZiFKmWHFBHspqNW_7dO4pZgzzhpadHOz9ksB_r2DF8gHB1o8mI3XXZ6Je&excludeArea=API&';
  if (projectId != '') {
    fetchUrl += 'projectId=' + projectId;
  }
  if (projectId != '' && versionName != '') {
    fetchUrl += '&';
  }

  if (versionName != '') {
    fetchUrl += 'versionName=' + versionName;
  }

  if ((projectId != '' || versionName != '') && searchStr != '') {
    fetchUrl += '&';
  }

  if (searchStr != '') {
    const isNumber = Number(searchStr);

    if (isNaN(isNumber)) {
      fetchUrl += 'text=' + searchStr.toLowerCase();
    } else {
      fetchUrl += 'workItemId=' + searchStr;
    }
  }

  try {
    const response = await fetch(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    const result = await response.json();

    const sortedResult = result.slice().sort((a: any, b: any) => {
      return compareVersions(a.versionName, b.versionName);
    });

    createChangelog(
      sortedResult,
      versionName,
      projectId,
      urlVersion,
      preFilter
    );
    return allResults;
  } catch (err) {}
}

function filterBtn(element: changelogItem) {
  if (
    changelogCategories.length &&
    changelogCategories.indexOf(element.projectTitle) == -1
  ) {
    changelogCategories.push(element.projectTitle);
    objArray.push({ projectName: element.projectTitle });
    changelogCategories.sort();
  } else if (changelogCategories.length == 0) {
    changelogCategories.push(element.projectTitle);
    objArray.push({ projectName: element.projectTitle });
  }
}

function createChangelog(
  result: changelogItem[],
  versionName: string,
  projectId: string,
  urlVersion: boolean,
  preFilter?: string,
  hideVideo?: boolean
) {
  var ul = document.getElementById('changelog-ul');
  var changelogAreas: string[] = [];
  ul.innerHTML = '';

  result.forEach(function (element: changelogItem) {
    var li = document.createElement('li');
    var elementUl = document.createElement('ul');
    var elementLi = document.createElement('li');
    var datePublished = new Date(element.datePublished);
    var publishMonth = getChangeMonth(datePublished);
    var changelogLang = element.changelogEN;
    var hasVideo = '';
    var sameVersion = '';
    li.setAttribute('id', 'changelog-item');

      if (element.changelogVideo != null && element.changelogVideo != "" && hideVideo != true) {
      hasVideo = 'video';
    }
    if (versionName != '' && element.versionName == versionName) {
      sameVersion = 'same-version';
    }
    li.innerHTML =
      "<div id='element' data-projectname='" +
      element.projectTitle +
      "' data-version='" +
      element.versionName +
      "' class='mix y" +
      parseFloat(element.versionName).toString().replace('.', '') +
      ' ' +
      sameVersion +
      ' ' +
      hasVideo +
      ' ' +
      element.projectTitle
        .toLowerCase()
        .replace(/ä/g, 'a')
        .replace(/å/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/ /g, '-') +
      "'><h3 class=''>" +
      element.versionName +
      ' (Released  ' +
      publishMonth +
      ' ' +
      datePublished.getDate() +
      ', ' +
      datePublished.getFullYear() +
      ')</h3>';
    li.setAttribute('data-version', element.versionName);

    ul.appendChild(li);
    elementUl.classList.add('element-ul');
    if (versionName != '' && element.versionName == versionName) {
      elementUl.classList.add('same-version');
    }
    li.appendChild(elementUl);
    if (
      changelogCategories.length &&
      changelogCategories.indexOf(element.projectTitle) == -1
    ) {
      changelogCategories.push(element.projectTitle);
      objArray.push({ projectName: element.projectTitle });
      changelogCategories.sort();
    } else if (changelogCategories.length == 0) {
      changelogCategories.push(element.projectTitle);
      objArray.push({ projectName: element.projectTitle });
    }
    filterBtn(element);

      if (element.changelogVideo != null && element.changelogVideo != "" && hideVideo !== true) {
          var elementLi = document.createElement('li');
          var videos = [element.changelogVideo];
          if (element.changelogVideo_2 != null && element.changelogVideo_2 != "") videos.push(element.changelogVideo_2);
          if (element.changelogVideo_3 != null && element.changelogVideo_3 != "") videos.push(element.changelogVideo_3);

          var multipleVideos = `video-${videos.length}-container`;

          elementLi.classList.add(
              'video-li',
              'mix',
              'video',
              multipleVideos,
              'y' + parseFloat(element.versionName).toString().replace('.', ''),
              element.projectTitle
                  .toLowerCase()
                  .replace(/ä/g, 'a')
                  .replace(/å/g, 'a')
                  .replace(/ö/g, 'o')
                  .replace(/ /g, '-')
          );

          elementLi.innerHTML = videos.map(video =>
              `<div class='video-${videos.length}'><iframe width='100%' height='100%' loading='lazy' src='${video}' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`
          ).join('');
          elementUl.appendChild(elementLi);
      }
    if (lang == 'sv-SE') {
      changelogLang = element.changelogSV;

      if (changelogLang.length == 0) {
        changelogLang = element.changelogEN;
      }
    } else {
      if (changelogLang.length == 0) {
        changelogLang = element.changelogSV;
      }
    }

    var patchType = '';
    var patchCategories: changelogMajor[] = [];
    for (var i = 0; i < changelogAreas.length; i++) {
      patchCategories.push({ name: changelogAreas[i], items: null });
    }

    changelogLangArr = changelogLang;
    if (versionName == '' || element.versionName == versionName) {
      changelogLangArr = changelogLangArr.sort((a, b) => {
        if (a.area < b.area) {
          return -1;
        }
      });
      changelogLangArr = changelogLangArr.sort(function (a, b) {
        if (changelogLang == element.changelogEN) {
          const indexA = customOrder.indexOf(a.area);
          const indexB = customOrder.indexOf(b.area);
          if (indexA !== indexB) {
            return indexA - indexB;
          }

          if (a.isTopNews !== b.isTopNews) {
            return a.isTopNews ? -1 : 1;
          }

          if (a.type !== b.type) {
            if (a.type < b.type) {
              return 1;
            } else if (a.type > b.type) {
              return -1;
            }
          }
          return a.id - b.id;
        } else {
          const indexA = customOrderSwedish.indexOf(a.area);
          const indexB = customOrderSwedish.indexOf(b.area);
          if (indexA !== indexB) {
            return indexA - indexB;
          }

          if (a.isTopNews !== b.isTopNews) {
            return a.isTopNews ? -1 : 1;
          }

          if (a.type !== b.type) {
            if (a.type > b.type) {
              return 1;
            } else if (a.type < b.type) {
              return -1;
            }
          }
          return a.id - b.id;
        }
      });
    } else {
      changelogLang = changelogLang.sort((a, b) => {
        if (changelogLang == element.changelogEN) {
          if (a.type < b.type) {
            return 1;
          } else if (a.type > b.type) {
            return -1;
          }
          if (a.isTopNews < b.isTopNews) {
            return 1;
          } else if (a.isTopNews > b.isTopNews) {
            return -1;
          } else if (a.id > b.id) {
            return 1;
          } else if (a.id < b.id) {
            return -1;
          }
        } else {
          if (a.type > b.type) {
            return 1;
          } else if (a.type < b.type) {
            return -1;
          } else {
            if (a.isTopNews < b.isTopNews) {
              return 1;
            } else if (a.isTopNews > b.isTopNews) {
              return -1;
            } else if (a.id > b.id) {
              return 1;
            } else if (a.id < b.id) {
              return -1;
            } else return 0;
          }
        }
      });
    }

    if (versionName == '' || element.versionName == versionName) {
      changelogLang = changelogLangArr;
    }

    for (var i = 0; i < changelogLang.length; i++) {
      if (element.versionName == versionName) {
        if (
          patchCategory.area == changelogLang[i].area &&
          patchCategory.value == element.versionID.toString()
        ) {
        } else {
          patchCategory.area = changelogLang[i].area;
          patchCategory.value = element.versionID.toString();
          var elementLi = document.createElement('li');
          elementLi.classList.add(
            'change-headline',
            changelogLang[i].area
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-'),
            'mix',
            'y' + parseFloat(element.versionName).toString().replace('.', ''),
            element.projectTitle
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-')
          );
          elementLi.innerHTML =
            "<h3><img src='/images/changelog/" +
            changelogLang[i].area
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-') +
            ".png'/><span>" +
            patchCategory.area +
            '</span></h3>';
          elementUl.appendChild(elementLi);
        }
        if (patchType != changelogLang[i].type) {
          patchType = changelogLang[i].type;
          var elementLi = document.createElement('li');
          elementLi.classList.add(
            'change-type',
            changelogLang[i].area
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-'),
            'mix',
            'y' + parseFloat(element.versionName).toString().replace('.', ''),
            element.projectTitle
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-')
          );

          elementLi.innerHTML = '<h3><span>' + patchType + '</span></h3>';
          elementUl.appendChild(elementLi);
        }
      }

      var elementLi = document.createElement('li');
      var topNews = '';
      if (changelogLang[i].isTopNews == true) {
        topNews = 'top-news';
      }
      if (element.versionName == versionName || versionName == '') {
      } else {
        if (patchType != changelogLang[i].type) {
          patchType = changelogLang[i].type;
          var elementLiHeadline = document.createElement('li');
          elementLiHeadline.classList.add(
            'change-type',
            changelogLang[i].area
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-'),
            'mix',
            'y' + parseFloat(element.versionName).toString().replace('.', ''),
            element.projectTitle
              .toLowerCase()
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-')
          );

          elementLiHeadline.innerHTML =
            '<h5><span>' + patchType + '</span></h5>';
          elementUl.appendChild(elementLiHeadline);
        }
      }
      elementLi.classList.add(
        'patch-item-standard',
        element.projectTitle.toLowerCase().replace(/ /g, '-'),
        changelogLang[i].area
          .toLowerCase()
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o')
          .replace(/ /g, '-'),
        'mix',
        'y' + parseFloat(element.versionName).toString().replace('.', ''),
        element.projectTitle
          .toLowerCase()
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o')
          .replace(/ /g, '-')
      );
      elementLi.setAttribute('data-version', element.versionName);
      elementLi.setAttribute(
        'data-versionNumber',
        changelogLang[i].id.toString()
      );
      elementLi.setAttribute('data-projectName', element.projectTitle);

      var textType = changelogLang[i].rawText;

      if (element.versionName == versionName || versionName == '') {
        textType = changelogLang[i].text;
      }
      if (changelogLang[i].isTopNews == true) {
        elementLi.classList.add('top-news');
        textType = changelogLang[i].text;
      }

      elementLi.innerHTML =
        '<span>' +
        textType +
        " </span><span class='change-item-id'>(" +
        changelogLang[i].id +
        ')</span>';
      if (changelogLang[i].isTopNews == false) {
      }
      elementUl.appendChild(elementLi);
      }
      if (element.changelogVideo != null && element.changelogVideo != "") {
      if (changelogAreas.length && changelogAreas.indexOf('Video') == -1) {
        changelogAreas.push('Video');
        changelogAreas.sort();
      } else if (changelogAreas.length == 0) {
        changelogAreas.push('Video');
      }
    }
    for (var i = 0; i < changelogLang.length; i++) {
      if (element.versionName == versionName || versionName == '') {
        li.children[0].classList.add(
          changelogLang[i].area
            .toLowerCase()
            .replace(/ä/g, 'a')
            .replace(/å/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ /g, '-')
        );
      } else {
        li.children[0].classList.add(
          changelogLang[i].area
            .toLowerCase()
            .replace(/ä/g, 'a')
            .replace(/å/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ /g, '-')
        );
      }
      if (
        changelogAreas.length &&
        changelogAreas.indexOf(changelogLang[i].area) == -1
      ) {
        changelogAreas.push(changelogLang[i].area);
        changelogAreas.sort();
      } else if (changelogAreas.length == 0) {
        changelogAreas.push(changelogLang[i].area);
      }
    }
  });
  if (lang == 'sv-SE') {
    if (changelogAreas.indexOf('Allt') == -1) {
      changelogAreas.unshift('Allt');
    }
  } else {
    if (changelogAreas.indexOf('All areas') == -1) {
      changelogAreas.unshift('All areas');
    }
  }

  if (projectId == '2') {
    createDropdownItems(changelogAreas, 'area-select', true, '2', urlVersion);
  }

  initFilterMixitup('all', preFilter);
}

function createDropdownItems(
  dropdownArr: string[],
  selectId: string,
  useIcons: boolean,
  projectId: string,
  versionUrl: boolean
) {
  if (selectId == 'version-select') {
    var versionContainer = document.getElementById('version-container');
    versionContainer.innerHTML = '';
    var newSelect = document.createElement('select');
    newSelect.setAttribute('id', 'version-select');
    versionContainer.appendChild(newSelect);
  }
  if (selectId == 'area-select') {
    var areaContainer = document.getElementById('area-container');
    areaContainer.innerHTML = '';
    var newSelect = document.createElement('select');
    newSelect.setAttribute('id', 'area-select');
    areaContainer.appendChild(newSelect);
    document.getElementById('area-container').style.display = 'block';
  }
  var createSelect = document.createElement('select');
  createSelect.setAttribute('id', selectId);
  var filterContainer = document.getElementById(selectId);

  for (var i = 0; i < dropdownArr.length; i++) {
    var option = document.createElement('option');
    var dropdownText = dropdownArr[i];
    if (selectId == 'version-select') {
      dropdownText = 'Version ' + dropdownArr[i];
    }

    option.setAttribute(
      'value',
      dropdownArr[i]
        .toLowerCase()
        .replace(/ä/g, 'a')
        .replace(/å/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/ /g, '-')
    );

    option.innerHTML =
      "<span data-call='" + dropdownArr[i] + "'>" + dropdownText + '</span>';
    filterContainer.appendChild(option);
  }
  if (selectId.length) {
    var searchStr = '';
    var searchInput = document.getElementById(
      'changelog-search'
    ) as HTMLInputElement;
    if (searchInput.value) {
      searchStr = searchInput.value;
    }
    if (searchStr == '') {
      customSelect(selectId, useIcons, projectId, versionUrl);
    } else {
      customSelect(selectId, useIcons, '', versionUrl);
    }
  }

  // initFilterMixitup(".video");
}
function createFilters(changelogCategories: changeLogBtn[]) {
  var filterContainer = document.getElementById('filter-container');

  for (var i = 0; i < changelogCategories.length; i++) {
    if (changelogCategories[i] != undefined) {
      var button = document.createElement('button');

      button.setAttribute(
        'data-filter',
        '.' +
          changelogCategories[i].title
            .toLowerCase()
            .replace(/ä/g, 'a')
            .replace(/å/g, 'a')
            .replace(/ö/g, 'o')
            .replace(/ /g, '-')
      );
      button.setAttribute(
        'data-call',
        changelogCategories[i].title
          .toUpperCase()
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o')
          .replace(/ /g, '+')
      );
      button.setAttribute('projectId', changelogCategories[i].id.toString());
      button.setAttribute('data-mixitup-control', '');
      button.setAttribute('id', changelogCategories[i].id.toString());

      button.addEventListener('click', function (this) {
        var projectIDBtn = this.getAttribute('id');
        var parentElement = this.parentElement;
        for (var i = 0; i < parentElement.children.length; i++) {
          if (
            parentElement.children[i].classList.contains(
              'mixitup-active-button'
            )
          ) {
            parentElement.children[i].classList.remove('mixitup-active-button');
          }
        }
        closeAllSelect(this);
        this.classList.add('mixitup-active-button');

        if (projectIDBtn != undefined && projectIDBtn != '2') {
          getChangelogVersions(projectIDBtn, false);
        }
        if (projectIDBtn == '2') {
          getChangelogVersions('2', true);
        } else {
          document.getElementById('area-container').style.display = 'none';
        }
        var searchInput = document.getElementById(
          'changelog-search'
        ) as HTMLInputElement;
        searchInput.value = '';
      });
      button.classList.add('filter-btn');
      button.innerHTML =
        "<div class='changelog-filter-button'><span>" +
        changelogCategories[i].title +
        '</span></div>';
      filterContainer.appendChild(button);
    }
  }
}

function getChangeMonth(datePublished: Date) {
  var month = '';
  switch (datePublished.getMonth()) {
    case 0:
      month = 'Jan';
      break;
    case 1:
      month = 'Feb';
      break;
    case 2:
      month = 'Mars';
      break;
    case 3:
      month = 'April';
      break;
    case 4:
      month = 'May';
      break;
    case 5:
      month = 'June';
      break;
    case 6:
      month = 'July';
      break;
    case 7:
      month = 'August';
      break;
    case 8:
      month = 'September';
      break;
    case 9:
      month = 'October';
      break;
    case 10:
      month = 'November';
      break;
    case 11:
      month = 'December';
      break;
  }
  return month;
}
function customSelect(
  itemClass: string,
  useIcons: boolean,
  projectId: string,
  versionUrl: boolean
) {
  var x, i, j, selElmnt, a, c;
  const urlParams = new URLSearchParams(window.location.search);
  const versionName = urlParams.get('VersionName');

  x = document.getElementsByClassName(itemClass);

  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0];

    a = document.createElement('div');
    a.setAttribute('class', 'select-selected', itemClass);
    a.setAttribute('id', 'selected');

    if (selElmnt.options[selElmnt.selectedIndex] != undefined) {
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

      if (
        versionName != null &&
        itemClass == 'version-select' &&
        versionUrl == true
      ) {
        a.innerHTML = 'Version ' + versionName;
      }

      if (useIcons == true) {
        var iconClass = a.textContent
          .toLowerCase()
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o')
          .replace(/ /g, '-')
          .replace('.', '');
        if (iconClass == 'all-areas' || iconClass == 'allt') {
          iconClass = 'all';
        }
        a.classList.add('useIcons');
        a.classList.add(iconClass);
      } else {
        a.classList.add(
          'y' +
            a.textContent
              .toLowerCase()
              .replace('version ', '')
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-')
              .replace('.', '')
        );
      }
      x[i].appendChild(a);

      var secondDiv = document.createElement('div');
      secondDiv.setAttribute('class', 'select-items select-hide');
      secondDiv.setAttribute('id', itemClass + '-fields');
      secondDiv.setAttribute('data-logic', 'and');
      secondDiv.setAttribute('data-filter-group', itemClass + '-fields');
    }

    for (j = 0; j < selElmnt.length; j++) {
      c = document.createElement('button');
      var dropdownOptionText = selElmnt.options[j].innerHTML;
      c.setAttribute('data-mixitup-control', '');
      var dropdownClass = selElmnt.options[j].value
        .toLowerCase()
        .replace('.', '');

      if (itemClass == 'version-select') {
        dropdownClass = 'y' + dropdownClass;
      }
      if (dropdownClass == 'all-areas' || dropdownClass == 'allt') {
        dropdownClass = 'all';
      }

      c.classList.add('dropdown-item', dropdownClass);
      if (dropdownClass != 'all') {
        dropdownClass = '.' + dropdownClass;
      }
      c.setAttribute('data-filter', dropdownClass);
      c.setAttribute('data-call', selElmnt.options[j].value.toLowerCase());

      if (useIcons == true) {
        c.classList.add('useIcons');
        c.innerHTML = dropdownOptionText;
      } else {
        c.innerHTML = dropdownOptionText;
      }

      c.addEventListener('click', function (e) {
        var targetVersion = e.target.getAttribute('data-call');
        var select =
          this.parentNode.parentNode.getElementsByTagName('select')[0];
        var prevSibling = this.parentNode.previousSibling;

        if (itemClass != 'area-select') {
          var searchStr = '';
          var searchInput = document.getElementById(
            'changelog-search'
          ) as HTMLInputElement;
          if (searchInput.value) {
            searchStr = searchInput.value;
          }

          var filterItems = document.querySelectorAll('.select-selected');
          var selectedFilter;
          var filterStr;
          if (filterItems != null && filterItems.length > 1) {
            selectedFilter = filterItems[1].children;

            if (selectedFilter != null) {
              filterStr = selectedFilter[0].getAttribute('data-call');
            }
          }

          getChangelog(projectId, targetVersion, false, searchStr, filterStr);
        } else {
          var targetFilter = e.target.getAttribute('data-filter');
          if (targetFilter == null) {
            targetFilter = e.target.parentElement.getAttribute('data-filter');
          }
          getChangelog(projectId, targetVersion, false, searchStr);
        }

        for (var i = 0; i < select.length; i++) {
          if (select.options[i].innerHTML == this.innerHTML) {
            select.selectedIndex = i;
            prevSibling.innerHTML = this.innerHTML;
            var sameAsSelected =
              this.parentNode.getElementsByClassName('same-as-selected');

            for (var k = 0; k < sameAsSelected.length; k++) {
              sameAsSelected[k].classList.remove('same-as-selected');
            }

            var itemFilter = this.textContent
              .toLowerCase()
              .replace('version ', '')
              .replace(/ä/g, 'a')
              .replace(/å/g, 'a')
              .replace(/ö/g, 'o')
              .replace(/ /g, '-');
            if (itemClass == 'version-select') {
              itemFilter = 'y' + itemFilter.replace('.', '');
            }

            if (itemFilter == 'all-areas' || itemFilter == 'allt') {
              itemFilter = 'all';
            }

            this.setAttribute(
              'class',
              'same-as-selected dropdown-item' + ' ' + itemFilter
            );
            if (useIcons == true) {
              this.classList.add('useIcons');
            }
            break;
          }
        }
        prevSibling.click();
      });
      secondDiv.appendChild(c);
    }
    if (secondDiv != undefined) {
      x[i].appendChild(secondDiv);
    }
    a.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  }
  // if(projectId == "2"){

  // }else {

  //   // document.getElementById("area-container").style.display = "none";

  // }
  // var firstVersion = document.getElementById("version-select-fields").children[0] as HTMLButtonElement;
  //   firstVersion.click();
  // document.addEventListener("click", closeAllSelect);
  // var changelog = document.getElementById("changelog") as HTMLDivElement;
  // changelog.click();
}

var versionSelect = document.getElementsByClassName('version-select');
var versionClass = versionSelect[0].querySelector('.select-selected');

var lastVersion = '';

if (versionClass != null) {
  lastVersion = '.' + versionClass.classList[versionClass.classList.length - 1];
}
var btnContainer = document.getElementById('filter-container');
var firstBtnItem = btnContainer.children[0];
var btnText = '';
var btnCall = '';

if (firstBtnItem != undefined) {
  btnText = firstBtnItem.getAttribute('data-filter');
  btnCall = firstBtnItem.textContent.replace(/ /g, '+');
}

function initFilterMixitup(preClass: string, preFilter?: string) {
  var containerEl = document.getElementById('changelog-container');
  var allMix = document.querySelectorAll('.mix');

  var mixer = mixitup(containerEl, {
    animation: {
      duration: 0,
    },
    load: {
      filter: preClass,
    },
    behavior: {
      liveSort: true,
    },
    multifilter: {
      enable: true,
    },
  });
  mixer.forceRefresh();

  if (preFilter != null && preFilter != 'All areas' && preFilter != 'Allt') {
    const filterElement = document.querySelector(
      '[data-call="' +
        preFilter
          .toLowerCase()
          .replace(' ', '-')
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o') +
        '"]'
    ) as HTMLButtonElement;
    const selectedAll = document.querySelectorAll('.select-selected');
    const selectedItem = selectedAll[1] as HTMLDivElement;

    if (filterElement != null && selectedItem != null) {
      filterElement.click();
      selectedItem.click();
    }
  }

  for (var i = 0; i < allMix.length; i++) {
    var referenceElement = mixer.getState().show[1];
    mixer.insertBefore(allMix[i], referenceElement);
  }
}

function onMixEnd() {
  var selected = document.querySelectorAll('.mixitup-control-active');
  var filterBtn = '';
  var projectId = '';
  var filterMix = '';
  var dropdownMix = '';
  for (var i = 0; i < selected.length; i++) {
    if (selected[i].classList.contains('dropdown-item')) {
      dropdownMix = selected[i].getAttribute('data-filter');
    } else {
      filterBtn = selected[i].getAttribute('data-call');
      projectId = selected[i].getAttribute('projectid');
      filterMix = selected[i].getAttribute('data-filter');
    }
  }

  var filterArr: string[] = [];
  var activeFilters = document.querySelectorAll('.mixitup-control-active');

  for (var i = 0; i < activeFilters.length; i++) {
    filterArr.push(
      activeFilters[i].getAttribute('data-filter').replace('.', '')
    );
  }
}

function closeAllSelect(elmnt) {
  var arrNo = [];
  var selectItems = document.getElementsByClassName('select-items');
  var selected = document.getElementsByClassName('select-selected');

  for (var i = 0; i < selected.length; i++) {
    if (elmnt == selected[i]) {
      arrNo.push(i);
      var innerText = selected[i].textContent;
      var classItems = 'select-selected';
      if (selected[i].classList.contains('useIcons')) {
        classItems = classItems + ' useIcons';
      }
      if (selected[i].classList.contains('select-arrow-active')) {
        classItems = classItems + ' select-arrow-active';
      }
      selected[i].setAttribute('class', classItems);
      selected[i].classList.add(
        innerText
          .toLowerCase()
          .replace('version ', '')
          .replace(/ä/g, 'a')
          .replace(/å/g, 'a')
          .replace(/ö/g, 'o')
          .replace(/ /g, '-')
      );
    } else {
      selected[i].classList.remove('select-arrow-active');
    }
  }
  for (var i = 0; i < selectItems.length; i++) {
    if (arrNo.indexOf(i)) {
      selectItems[i].classList.add('select-hide');
    }
  }
}
window.addEventListener('click', (event) => {
  var targetElem = event.target as HTMLDivElement;
  if (
    targetElem.getAttribute('id') != 'changelog-seach' &&
    targetElem.getAttribute('id') != 'search-results'
  ) {
    var resultsUl = document.getElementById('search-results');
    resultsUl.innerHTML = '';
    resultsUl.classList.remove('shadow');
  }
});
var inputField = document.getElementById(
  'changelog-search'
) as HTMLInputElement;
var keyPressCount = 0;

inputField.addEventListener('search', function (event) {
  if (inputField.value.length == 0) {
    var resultsUl = document.getElementById('search-results');
    resultsUl.innerHTML = '';
    resultsUl.classList.remove('shadow');
  }
});
let timeoutId;

inputField.addEventListener('keyup', (event) => {
  var resultsUl = document.getElementById('search-results');

  if (event.key == 'Enter') {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      resultsUl.innerHTML = '';
      resultsUl.classList.remove('shadow');
    }, 300);
  } else if (event.key !== 'Enter') {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const inputValue = inputField.value.trim();
      if (inputValue != '') {
        getChangelogSearch(inputValue);
      }

      getChangelogVersions('', false);
    }, 300);
  }
});
async function getChangelogSearch(searchStr: string) {
  var fetchUrl =
    'https://changelogapi.monitor.se/api/changelog/changes?apiKey=XMEWLZiFKmWHFBHspqNW_7dO4pZgzzhpadHOz9ksB_r2DF8gHB1o8mI3XXZ6Je&excludeArea=API';

  if (searchStr != '') {
    const isNumber = Number(searchStr);

    if (isNaN(isNumber)) {
      fetchUrl += '&text=' + searchStr.toLowerCase();
    } else {
      fetchUrl += '&workItemId=' + searchStr;
    }
  }
  try {
    const response = await fetch(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error! status: ${response.status}`);
    }
    var result = await response.json();
    const sortedResult = result.slice().sort((a: any, b: any) => {
      return compareVersions(a.versionName, b.versionName);
    });
    var resultsUl = document.getElementById('search-results');
    var selectedScroll = document.querySelectorAll('.selected-scroll');
    for (var i = 0; i < selectedScroll.length; i++) {
      selectedScroll[i].classList.remove('selected-scroll');
    }
    resultsUl.innerHTML = '';
    resultsUl.classList.add('shadow');

    var loopCount = result.length;
    if (loopCount > 20) {
      loopCount = 20;
    }

    for (var i = 0; i < loopCount; i++) {
      var changelogLang = result[i].changelogEN;
      if (lang == 'sv-SE') {
        changelogLang = result[i].changelogSV;

        if (changelogLang.length == 0) {
          changelogLang = result[i].changelogEN;
        }
      } else {
        if (changelogLang.length == 0) {
          changelogLang = result[i].changelogSV;
        }
      }
      var activeBtn = document.querySelector('.mixitup-active-button');
      if (activeBtn != null) {
        activeBtn.classList.remove('mixitup-active-button');
      }
      document.getElementById('area-container').style.display = 'none';
      var innerContent = '';
      var versionNo;

      innerContent = innerContent.replace(/ *\([^)]*\) */g, '');
      for (var j = 0; j < changelogLang.length; j++) {
        if (
          changelogLang[j].rawText
            .toLowerCase()
            .indexOf(searchStr.toLowerCase()) > -1
        ) {
          var newLi = document.createElement('li');

          innerContent = changelogLang[j].rawText;
          if (innerContent.length > 150) {
            innerContent = innerContent.slice(0, 150) + '...';
          }

          if (changelogLang[j].id != null) {
            versionNo = changelogLang[j].id;
          } else {
            versionNo = '';
          }

          newLi.innerHTML =
            "<div class='outer-content'><div class='inner-content'><span class='project-name'>" +
            result[i].projectTitle +
            ' - ' +
            result[i].versionName +
            "</span><span class='version-no'>" +
            versionNo +
            "</span></div><span class='text-content'>" +
            innerContent +
            '</span></div>';
          newLi.setAttribute('data-version-no', result[i].versionName);
          newLi.setAttribute('data-version-number', versionNo);
          resultsUl.appendChild(newLi);
          newLi.addEventListener('click', function (this) {
            var elementScroll = this.getAttribute('data-version-no');
            var versionNumber = this.getAttribute('data-version-number');

            var scrollItem = document.querySelectorAll(
              "[data-version='" + elementScroll + "']"
            );
            var scrollItemVersion = document.querySelectorAll(
              "[data-versionnumber='" + versionNumber + "']"
            );

            var scrollTo = scrollItemVersion[0] as HTMLDivElement;
            var scrollToItem = scrollItem[0] as HTMLDivElement;
            if (scrollTo == null) {
              scrollTo = scrollToItem;
            }
            scrollTo.classList.add('selected-scroll');

            const y = scrollTo.getBoundingClientRect().top + window.scrollY;
            window.scroll({
              top: y - 150,
              behavior: 'smooth',
            });

            resultsUl.innerHTML = '';
          });
        }
      }
    }
    createChangelog(sortedResult, '', '', false, '', true);

    return result;
  } catch (err) {}
}
var inputSearch = document.getElementById(
  'changelog-search'
) as HTMLInputElement;
if (inputSearch != null) {
  inputSearch.addEventListener('search', function () {
    if (inputSearch.value == '') {
      getChangelogVersions('', false);
    } else {
      getChangelogSearch(inputSearch.value);
    }
  });
}
